export default __webpack_public_path__ + "static/media/create_token.9742a16d.png";